
export default function getBaseServiceOptions() {
    return {
        baseUrl: '/service',
    };
}
